import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useStandardTroopSchedule from "./hooks/useStandardTroopSchedule";  
  
const StandardTroopSchedule = () => {  
  const standardTroopScheduleData = useStandardTroopSchedule();  
  return (  
    <div class="container container-fluid">  
      <ButtonsSection ctaButtons={standardTroopScheduleData.leftButtons} align="left" /> 
      <div className="header-section">  
        <h1>  
          {standardTroopScheduleData.screen_title} -{" "}  
          <span className="heading-cod">{standardTroopScheduleData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={standardTroopScheduleData.formFields}  
        dropdownValues={standardTroopScheduleData.dropdownValues}  
        paramsData={standardTroopScheduleData.paramsData}  
        updataParamData={standardTroopScheduleData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={standardTroopScheduleData.ctaButtons} />  
      <DisplayTable  
        data={standardTroopScheduleData.data}  
        parmKey={standardTroopScheduleData.parmKey}  
        menuOptions={standardTroopScheduleData.menuOptions}  
        tableHeaders={standardTroopScheduleData.columnDef}  
        setRowData={standardTroopScheduleData.setRowData}  
        selectedPriceSchedules={standardTroopScheduleData.selectedRows}  
        setSelectedPriceSchedules={standardTroopScheduleData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={standardTroopScheduleData.first}  
          rows={standardTroopScheduleData.rows}  
          totalRecords={standardTroopScheduleData.totalRecords}  
          currentPage={standardTroopScheduleData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={standardTroopScheduleData.onPageChange}  
        />  
      </div>  
    </div>  
  );  
};  
  
export default StandardTroopSchedule;